import React from 'react'
import styled from 'styled-components'
import theme from 'styled-theming'

import { COLORS, hoverSelector, THEME, typeScale } from '../../styles'
import Icon from '../Icon'

const VARIANTS = {
  background: theme('variant', {
    page: THEME.COLORS.background.primary,
    footer: THEME.COLORS.default.white,
  }),
  color: theme('variant', {
    page: THEME.COLORS.foreground.primary,
    footer: THEME.COLORS.default.black,
  }),
  separator: theme('variant', {
    page: THEME.COLORS.foreground.tertiary,
    footer: THEME.COLORS.foreground.tertiary,
  }),
}

const Styled = styled.div`
  display: block;
  user-select: none;
  color: ${VARIANTS.color};
`
Styled.tootipContainer = styled.div`
  padding-top: 0.8rem;
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 20rem;
  z-index: 1;

  &:after {
    content: ' ';
    position: absolute;
    top: 0;
    left: 1.6rem;
    margin-left: -1.2rem;
    border-width: 0 1.2rem 1.6rem;
    border-style: solid;
    border-color: transparent transparent ${VARIANTS.background} transparent;
    z-index: 1;
  }
`
Styled.tooltipContent = styled.div`
  background-color: ${VARIANTS.background};
  border-radius: 1.6rem;
  padding: 0.4rem 0.8rem;
`
Styled.tooltip = styled.div`
  background-color: ${VARIANTS.background};
  border-radius: 2.4rem;
  height: 3.2rem;
  padding: 0 0.8rem;
  display: inline-block;
  cursor: pointer;
  position: relative;
  color: ${VARIANTS.color};
  ${({ isOpen }) => `
    ${Styled.tootipContainer} {
      display: ${isOpen ? 'block' : 'none'};
    }
  `};
`
Styled.tooltipDiscoverable = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
`
Styled.tooltipDiscoverableLanguage = styled.span`
  ${typeScale('caption')};
  display: inline-block;
  flex: 1;
  padding: 0 0.4rem;
  color: ${COLORS.black};
  color: ${VARIANTS.color};
`
Styled.tooltipDiscoverableDropdown = styled(({ isOpen, ...rest }) => (
  <Icon {...rest} />
))`
  width: 1.6rem;
  height: 1.6rem;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  display: block;
  fill: ${VARIANTS.color};
`
Styled.separator = styled.hr`
  height: 0.1rem;
  border: 0;
  border-bottom: 0.1rem solid ${VARIANTS.separator};
  width: 100%;
  margin: 0;
`
Styled.availabilityZoneFlag = styled.span`
  ${typeScale('caption')};
  display: inline-block;
`
Styled.availabilityZoneName = styled.span`
  ${typeScale('caption')};
  display: inline-block;
  padding: 0 0.4rem;
  flex: 1;
  transition: color 0.2s ease-in-out;
  color: ${COLORS.black};
`
Styled.availabilityZoneCheck = styled(Icon)`
  display: block;
  width: 1.6rem;
  height: 1.6rem;
`
Styled.availabilityZone = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0.4rem 0;
  margin: 0.4rem 0;
  ${Styled.availabilityZoneName} {
    color: ${({ isChecked }) => (isChecked ? COLORS.primary : VARIANTS.color)};
  }
  ${hoverSelector(Styled.availabilityZoneName)`
    color: ${COLORS.primary};
  `}
`

export default Styled
